export default __webpack_public_path__ + "static/media/noImage.8929fbad.jpg";